import React, { useState } from 'react'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import MaterialTable, { MTableToolbar } from '@material-table/core'
import { AiFillEdit } from 'react-icons/ai'
import { IconButton } from '@material-ui/core'
import ModalConfigPage from './ModalConfigPage'

const ConfigPage = ({ partners, bosses, regions, handleSaveInformation, groupList }) => {
  const [partnerInfo, setPartnerInfo] = useState({
    open: false,
    info: [],
  })
  const columns = [
    {
      title: 'Código SAP',
      field: 'codSap',
      editable: 'never',
      cellStyle: {
        color: '#E2A233',
      },
    },
    {
      title: 'Socio',
      field: 'razonSocial',
      editable: 'never',
      cellStyle: {
        color: '#2699FB',
      },
    },
    { title: 'Reponsable', field: 'jefe', editable: 'never', },
    { title: 'Región', field: 'territorio', editable: 'never', cellStyle: { textTransform: 'uppercase' }, },
    { title: 'Grupo', field: 'idGrupo', editable: 'never', cellStyle: { textTransform: 'uppercase' }, },
    {
      title: 'Seleccionar jefe y región',
      field: 'Seleccionar jefe',
      render: (rowData) => (
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <IconButton
            style={{ width: '40px', color: 'black' }}
            onClick={() =>
              setPartnerInfo({
                open: true,
                info: rowData,
              })
            }
          >
            <AiFillEdit />
          </IconButton>
        </div>
      ),
    },
  ]

  return (
    <div>
      <ModalConfigPage
        groupList={groupList}
        open={partnerInfo.open}
        bossesList={bosses.map((user) => ({
          name: `${user.nombre} ${user.apellido}`,
          id: user.id,
        }))}
        regionsList={regions}
        partnerInfo={partnerInfo.info}
        handleSaveInformation={(params) => handleSaveInformation(params)}
        handleClose={() =>
          setPartnerInfo({
            open: false,
            info: [],
          })
        }
        options={[]}
      />
      <CardTitle title="Listado de socios comerciales" />
      <MaterialTable
        // key={`info_key-${partnerInfo.open}`}
        style={{
          color: '#5A5A5A',
          fontWeight: 600,
        }}
        title="Configuración"
        columns={columns}
        data={partners}
        components={{
          Toolbar: (props) => (
            <div
              style={{
                background: '#FCFCFC',
                color: '#E2A233',
              }}
            >
              <MTableToolbar {...props} />
            </div>
          ),
        }}
        options={{
          showSelectAllCheckbox: false,
          selection: false,
          headerStyle: {
            backgroundColor: '#F6F6F6',
            color: '#161615',
            fontSize: '14px',
            fontWeight: 700,
            textAlign: 'center',
          },
          actionsColumnIndex: -1,
        }}
        localization={{
          toolbar: {
            addRemoveColumns: 'Agregar o eliminar columnas',
            exportAriaLabel: 'Exportar',
            exportName: 'Exportar a CSV',
            exportTitle: 'Exportar',
            nRowsSelected: '{0} filas seleccionadas',
            searchPlaceholder: 'Buscar',
            searchTooltip: 'Buscar',
            showColumnsAriaLabel: 'Mostrar columnas',
            showColumnsTitle: 'Mostrar columnas',
          },
        }}
      />
    </div>
  )
}

export default ConfigPage
